/**
 * A convenience method used to simulate loading.
 * @param seconds The amount of seconds to wait.
 */
export const wait = (seconds: number) =>
  new Promise((res) => {
    setTimeout(() => res(null), seconds * 1000)
  })
